import { render, staticRenderFns } from "./SucessoModal.vue?vue&type=template&id=5bc66b46&scoped=true"
import script from "./SucessoModal.vue?vue&type=script&lang=js"
export * from "./SucessoModal.vue?vue&type=script&lang=js"
import style0 from "./SucessoModal.vue?vue&type=style&index=0&id=5bc66b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc66b46",
  null
  
)

export default component.exports